import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { delay: Number };
  static outlets = ["activator"];

  connect() {
    console.log("long-press#connect", this.activatorOutlet);
    this.longPressTimer = null;
    this.delayValue = this.delayValue || 500; // Default to 500ms if not set
  }

  start(event) {
    console.log("long-press#start");
    event.stopPropagation();
    this.longPressTimer = setTimeout(() => {
      this.triggerLongPress(event);
    }, this.delayValue);
  }

  cancel() {
    clearTimeout(this.longPressTimer);
  }

  triggerLongPress(event) {
    event.preventDefault();
    event.stopPropagation();

    console.log("long-press#triggerLongPress");
    if (this.hasActivatorOutlet) {
      console.log("long-press#activating");
      this.activatorOutlet.activated(event);
    }
  }
}
